var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-right",staticStyle:{"width":"210px","float":"right"}},[_c('DatePickerInField',{attrs:{"label":"fecha","value":this.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }